/* @flow */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Dropdown extends Component {
  
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  }

  static childContextTypes = {
    dropdownIsInside: PropTypes.bool
  }

  static defaultProps = {
    className: 'geneva-dropdown'
  }


  getChildContext() {
    return { dropdownIsInside: true }
  }

  render() {

    const { isScrollable } = this.props

    return (
      <ul className={isScrollable
        ? `${this.props.className} scroll-container`
        : this.props.className
      }>
        {this.props.children}
      </ul>)
  }

}
